import {Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';
import {IPicture} from '@api/models/image/picture';
import {INewsPost} from '@api/models/news/news';
import {NewsService} from '@app/core/services/news.service';
import {ImageService} from '@utils/services/image/image.service';
import {IUTMParameters} from '@utils/services/url/url.service';

@Component({
  selector: 'app-news-top',
  templateUrl: './news-top.component.html',
  styleUrls: ['./news-top.component.scss', './news-top-embedded.component.scss']
})
export class NewsTopComponent implements OnInit, OnChanges {

  public picture: IPicture;
  public authorImgUrl: string;
  public authorName: string;
  public preTitle: string;
  public title: string;
  public preview_text: string;
  public targetRes: IMAGE_RESOLUTION;
  public authorBackground: string;
  @Input() public lazyLoadImage = true;
  @Input() public preloadImage = false;
  @Input() public news: INewsPost;
  @Input() public linkUtmParams: IUTMParameters;
  @HostBinding('class.large') @Input() public isLarge = false;
  @HostBinding('class.rise-on-hover') private riseOnHover = true;

  public ngOnInit(): void {
    if (!this.isLarge) {
      this.targetRes = IMAGE_RESOLUTION.LOW;
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.news && this.news) {
      if (this.news.pictures?.length > 0) {
        this.picture = this.news.pictures[0];
      } else if (this.news.videos_native?.length > 0 && this.news.videos_native[0]?.preview) {
        this.picture = this.news.videos_native[0].preview;
      }

      this.authorImgUrl = ImageService.getPictureUrl(this.news.creator?.pictures[0], IMAGE_RESOLUTION.LOW);
      this.authorName = this.news.creator.name;
      this.title = NewsService.replaceFacebookImportTitle(this.news);
      this.preTitle = this.news.pretitle;
      this.preview_text = this.news.preview_text;
    }

    if (this.authorName.includes('Kronen Zeitung')) {
      this.authorBackground = '#e2001a';
    }
    if (this.authorName.includes('fan.at')) {
      this.authorBackground = '#03A85C';
    }
  }
}
